<template>
  <div>
    <div class="church_banner">
      <figure>
        <img src="/images/banner1.png" alt="logo" />
      </figure>
      <div class="church_cnt">
        <div class="church d-flex flex-wrap">
          <div class="church_left col-md-7">
            <div class="vedio_blog">
              <iframe
                src="https://player.vimeo.com/video/275753684?autoplay=0&color=126912&title=0&byline=0&portrait=0"
                width="640"
                height="360"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="church_rgt col-md-5">
            <div class="sign sign2">
              <div class="sign_in sign_in1">
                <div class="sign_hd">
                  <h2>Sign&nbsp;In</h2>
                </div>
                <form class="sign_form sign_form1" @submit.prevent="handleSubmit">
                  <ul>
                    <li>
                      <input
                        type="text"
                        v-model="email"
                        name="email"
                        :class="{ 'is-invalid': submitted && !email }"
                        placeholder="Username or Email"
                      />
                    </li>
                    <li>
                      <input
                        type="password"
                        v-model="password"
                        name="password"
                        :class="{ 'is-invalid': submitted && !password }"
                        placeholder="Password"
                      />
                    </li>
                    <li>
                      <button type="submit">Login</button>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <span>Forgot Password?</span>
                      </a>
                    </li>
                  </ul>
                </form>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>

    <div class="main_content"></div>
  </div>
</template>

<script>
import { includes } from 'lodash'
export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: '',
    submitted: false
  }),
  methods: {
    async handleSubmit(e) {
      this.submitted = true
      const { email, password } = this
      if (email && password) {
        this.submitted = true
        await this.$store.dispatch('login', [email, password])
        if (includes(this.$store.state.user.role, 'care')) {
          this.$router.push({ name: 'videoLibrary' })
        }
        if (includes(this.$store.state.user.role, 'individual')) {
          this.$router.push({ name: 'myChurchProfile' })
        }
      }
    }
  }
}
</script>
